import React from 'react';

import { createIcon } from '../createIcon';

function SvgPreference(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M0 10c0 .367.3.667.667.667H4V9.333H.667C.3 9.333 0 9.633 0 10zm0-8c0 .367.3.667.667.667h6V1.333h-6C.3 1.333 0 1.633 0 2zm6.667 9.333v-.666h4.666c.367 0 .667-.3.667-.667 0-.367-.3-.667-.667-.667H6.667v-.666C6.667 8.3 6.367 8 6 8c-.367 0-.667.3-.667.667v2.666c0 .367.3.667.667.667.367 0 .667-.3.667-.667zm-4-6.666v.666h-2C.3 5.333 0 5.633 0 6c0 .367.3.667.667.667h2v.666c0 .367.3.667.666.667C3.7 8 4 7.7 4 7.333V4.667C4 4.3 3.7 4 3.333 4c-.366 0-.666.3-.666.667zM12 6c0-.367-.3-.667-.667-.667h-6v1.334h6c.367 0 .667-.3.667-.667zM8.667 4c.366 0 .666-.3.666-.667v-.666h2c.367 0 .667-.3.667-.667 0-.367-.3-.667-.667-.667h-2V.667C9.333.3 9.033 0 8.667 0 8.3 0 8 .3 8 .667v2.666C8 3.7 8.3 4 8.667 4z"
          id="Preference_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <g transform="translate(2 2)">
          <path d="M0 0h12v12H0z" />
          <use fill="currentColor" xlinkHref="#Preference_svg__a" />
        </g>
      </g>
    </svg>
  );
}

export const PreferenceFilledIcon = createIcon(SvgPreference, 'PreferenceFilledIcon');
